import React from 'react';

import {
    TextField,
    MenuItem,
} from "@material-ui/core";

import {
    Translate,
} from "src/shared_modules/i18n";

import {
    COUNTRIES,
    countryToFlag,
} from "./country-list";


const CountrySelect = (props) => {
    let countries = COUNTRIES;
    countries.sort(function(a, b){
        if(a.label < b.label) { return -1; }
        if(a.label > b.label) { return 1; }
        return 0;
    });
    return(<TextField
            id="country-select"
            fullWidth
            select
            required={props.required}
            disabled={props.disabled}
            label={<Translate>person-labels.country</Translate>}
            value={props.value}
            error={props.error}
            onChange={props.onChange}
            variant="outlined"
            style={props.style}
            className={props.className}
        >
        <MenuItem key="none" value={""}><em><Translate>person-labels.foaChoose</Translate></em></MenuItem>
        { countries.map( (option) => {
            return( <MenuItem key={option.code} value={option.label} >
                {option.label} ({option.code})
            </MenuItem>);
        }) }
    </TextField>);
}

export default CountrySelect;
